import React from "react"
import { Modal, ModalBody } from "reactstrap"

const CancelModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "159px",
          width: "318px",
        }}
      >
        <ModalBody style={{ display: "grid", gap: "1rem", placeItems: "center", padding: "2rem" }}>
          <div style={{ fontWeight: 500 }}>Are you sure you Want to Cancel the subscription?</div>

          <div className="d-flex justify-content-between">
            <button className="btn" style={{ backgroundColor: "#fabc42", paddingInline: "3rem", color: "white" }} onClick={toggle}>
              No
            </button>
            <button className="btn" style={{ backgroundColor: "#f5f5f5", paddingInline: "3rem" }}>
              Yes
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default CancelModal
